import React from 'react';

/*
    - ihoDesignSystem
*/
import { Alert, Badge, Box, Button, Grid, Image, Modal, Typography } from '@iho-design-system/Loader';

/*
    - icons
*/
import InfoSVG from '../../assets/images/icons/info.svg';
import UserSVG from '../../assets/images/icons/user.svg';

/*
    - api
*/
import get from '../../api/get';

const History = ({ props, toggleHistoryProps }) => {

    /*
        - defaultData
    */
    const [ticketResult, setTicketResult] = React.useState([]);

    /*
        - fetchData
    */
    React.useEffect(() => {
        const fetchData = async () => {
            let ticketParameters = {
                ctrl: 'Tickets',
                method: 'GetTicket',
                query: props.selectedRequest.Id
            };
            let result = await get(ticketParameters);
            if (result.status === 200 && Object.keys(result.data).length > 0) {
                setTicketResult(result.data);
            }
        }
        fetchData();
    }, [props]);

    /*
        - cancelTicket
    */
    const cancelTicket = async () => {
        let parameters = {
            ctrl: 'Tickets',
            method: 'CancelTicket',
            query: props.selectedRequest.Id,
        };
        await get(parameters);
        closeCancelTicketModal();
        toggleHistoryProps();
    }

    /*
        - modal
    */
    const openCancelTicketModal = () => {
        document.querySelector(`.cancelTicketModal`).classList.remove('d-none');
    }

    const closeCancelTicketModal = () => {
        document.querySelector(`.cancelTicketModal`).classList.add('d-none');
    }

    return (
        <React.Fragment>
            <Box
                className={`d-flex align-item-center justify-content-between `}>
                <Box
                    className={`d-flex-wrap align-item-center`}>
                    <Typography
                        className={`d-block`}
                        component='h4'
                        ms={{
                            fontWeight: 'normal !important'
                        }}>
                        {props.selectedRequest.Title} ({props.selectedRequest.Id})
                    </Typography>
                    {props.selectedRequest.Status === 0 &&
                        <Badge
                            color='light'
                            ms={{
                                height: '100%',
                                whiteSpace: 'nowrap'
                            }}>
                            {props.selectedRequest.StatusTitle}
                        </Badge>
                    }
                    {props.selectedRequest.Status === 3 &&
                        <Badge
                            color='danger'
                            ms={{
                                whiteSpace: 'nowrap'
                            }}>
                            {props.selectedRequest.StatusTitle}
                        </Badge>
                    }
                </Box>
                <Box
                    className={`d-flex`}
                    ms={{
                        gap: '4px'
                    }}>
                    {props.selectedRequest.Status === 0 &&
                        <Button
                            onClick={openCancelTicketModal}
                            variant='outlined'
                            color='danger'>
                            لغو درخواست
                        </Button>
                    }
                    <Button
                        onClick={toggleHistoryProps}
                        variant='outlined'
                        color='primary'>
                        لیست درخواست‌ها
                    </Button>
                </Box>
            </Box>
            <Box
                className={`my-lg mt-0`} />
            {!!ticketResult.ChatHistory &&
                <Box
                    className={`bg-white p-lg border-solid border-light rounded-lg`}
                    ms={{
                        '@keyframes chatAnimation': {
                            'from': {
                                opacity: '0',
                                bottom: '-16px'
                            },
                            'to': {
                                opacity: '1',
                                bottom: '0'
                            }
                        }
                    }}>
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '0.5s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Typography>
                                سلام، من پشتیبان آنلاین شما هستم.
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '0.75s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Typography>
                                من 24 ساعته اینجا هستم تا به شما کمک کنم. چه کاری می توانم برای شما انجام دهم؟
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start justify-content-end position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '1s'
                        }}>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-left-0`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Typography
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                درخواست جدید
                            </Typography>
                        </Box>
                        <Box
                            className={`mx-xs ml-0 my-sm mb-0 rounded-circle`}>
                            <Image
                                src={UserSVG}
                                alt='info'
                                ms={{
                                    width: '18px',
                                    height: '18px'
                                }} />
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '1.25s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Typography>
                                کاربر عزیز، چه درخواستی دارید؟
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start justify-content-end position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '1.5s'
                        }}>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-left-0`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Typography
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                {props.selectedRequest.Title}
                            </Typography>
                        </Box>
                        <Box
                            className={`mx-xs ml-0 my-sm mb-0 rounded-circle`}>
                            <Image
                                src={UserSVG}
                                alt='info'
                                ms={{
                                    width: '18px',
                                    height: '18px'
                                }} />
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '1.75s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Typography>
                                لطفا رزرو مورد نظرتان را انتخاب یا کد پیگیری رزرو را وارد نمایید.
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start justify-content-end position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '2s'
                        }}>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-left-0`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-medium)'
                            }}>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                هتل {ticketResult.ChatHistory.split(',')[0]}
                            </Typography>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                {ticketResult.ChatHistory.split(',')[1]}
                            </Typography>
                            <Typography
                                className={`d-block`}
                                ms={{
                                    color: 'var(--white)'
                                }}>
                                کد پیگیری رزرو : {ticketResult.ReserveId}
                            </Typography>
                        </Box>
                        <Box
                            className={`mx-xs ml-0 my-sm mb-0 rounded-circle`}>
                            <Image
                                src={UserSVG}
                                alt='info'
                                ms={{
                                    width: '18px',
                                    height: '18px'
                                }} />
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '2.25s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Typography>
                                درخواست شما با موفقیت ارسال گردید.
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '2.5s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Typography>
                                لازم به ذکر است، ارسال درخواست به منزله تایید نهایی نبوده و پس از پیگیری کارشناسان ما، نتیجه از طریق پیامک به شما اعلام خواهد شد.
                            </Typography>
                        </Box>
                    </Box>
                    <Box
                        className={`w-100 my-sm`} />
                    <Box
                        className={`d-flex flex-wrap align-item-start position-relative`}
                        ms={{
                            opacity: '0',
                            bottom: '-16px',
                            animation: 'chatAnimation 0.25s linear',
                            animationFillMode: 'forwards',
                            animationDelay: '2.75s'
                        }}>
                        <Box
                            className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                            ms={{
                                backgroundColor: 'var(--gray-light)'
                            }}>
                            <Image
                                src={InfoSVG}
                                alt='info'
                                ms={{
                                    width: '12px',
                                    height: '12px'
                                }} />
                        </Box>
                        <Box
                            className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                            ms={{
                                maxWidth: '60%',
                                backgroundColor: 'var(--gray-light)',
                            }}>
                            <Typography
                                className={`d-block`}>
                                کد درخواست : {props.selectedRequest.Id}
                            </Typography>
                            <Typography
                                className={`d-block`}>
                                کد رزرو : {props.selectedRequest.ReserveId}
                            </Typography>
                            <Typography
                                className={`d-block`}>
                                نوع درخواست : {props.selectedRequest.Title}
                            </Typography>
                            <Typography
                                className={`d-block`}>
                                خلاصه درخواست : {ticketResult.TicketMessages[0].Message}
                            </Typography>
                        </Box>
                    </Box>
                    {ticketResult.TicketMessages[1] !== undefined &&
                        <React.Fragment>
                            <Box
                                className={`w-100 my-sm`} />
                            <Box
                                className={`d-flex flex-wrap align-item-start position-relative`}
                                ms={{
                                    opacity: '0',
                                    bottom: '-16px',
                                    animation: 'chatAnimation 0.25s linear',
                                    animationFillMode: 'forwards',
                                    animationDelay: '3s'
                                }}>
                                <Box
                                    className={`p-xs mx-xs mr-0 my-sm mb-0 rounded-circle`}
                                    ms={{
                                        backgroundColor: 'var(--gray-light)'
                                    }}>
                                    <Image
                                        src={InfoSVG}
                                        alt='info'
                                        ms={{
                                            width: '12px',
                                            height: '12px'
                                        }} />
                                </Box>
                                <Box
                                    className={`px-md py-xs rounded-sm rounded-bottom-right-0 toggle-opaccity`}
                                    ms={{
                                        maxWidth: '60%',
                                        backgroundColor: 'var(--gray-light)',
                                    }}>
                                    <Typography
                                        className={`d-block`}>
                                        {ticketResult.TicketMessages[1].Message}
                                    </Typography>
                                </Box>
                            </Box>
                        </React.Fragment>
                    }
                </Box>
            }
            {ticketResult.ChatHistory === null &&
                <Alert
                    color='warning'
                    ms={{
                        position: 'static'
                    }}>
                    تاریخچه ای برای این تیکت یافت نشد.
                </Alert>
            }
            <Modal
                className={`cancelTicketModal`}>
                <Modal.Wrapper
                    size='xs'
                    ms={{
                        '@media(max-width:576px)': {
                            width: '100% !important'
                        }
                    }}>
                    <Modal.Header>
                        <Box />
                    </Modal.Header>
                    <Box
                        className={`p-sm`}
                        component='form'>
                        <Grid>
                            <Grid.Wrapper>
                                <Grid.Item
                                    size='col-12'>
                                    <Typography
                                        className={`d-block`}>
                                        آیا کنسل شدن {props.selectedRequest.Title} ({props.selectedRequest.Id}) را تایید می نمایید؟
                                    </Typography>
                                </Grid.Item>
                                <Grid.Item
                                    className={'d-flex'}
                                    size='col-6'>
                                    <Button
                                        onClick={cancelTicket}
                                        variant='filled'
                                        color='danger'>
                                        تایید
                                    </Button>
                                    <Box
                                        className={`mx-sm`} />
                                    <Button
                                        onClick={closeCancelTicketModal}
                                        variant='outlined'
                                        color='primary'>
                                        انصراف
                                    </Button>
                                </Grid.Item>
                            </Grid.Wrapper>
                        </Grid>
                    </Box>
                </Modal.Wrapper>
            </Modal>
        </React.Fragment >
    );

}

export default History;